import { useMemo } from 'react';
import { useConfigProperty } from '@leagueplatform/core';
import { useAnalyticsIdentify } from '@leagueplatform/web-common';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { BasePage } from 'components/base-page/base-page.component';
import { useOnboarding } from 'hooks/use-onboarding/use-onboarding.hook';
import { ErrorState } from 'components/error-state/error-state.component';
import { ERROR_TYPES } from 'hooks/use-error-content/use-error-content.hook';

export const PrivateRoutesContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { isLoading, currentStep, error } = useOnboarding();

  // Send user data to analytics SDK
  const tenantId = useConfigProperty('core.tenantId');
  const identifyOptions = useMemo(
    () => ({
      employer_group_id: '',
      tenant_id: tenantId!,
    }),
    [tenantId],
  );
  useAnalyticsIdentify(identifyOptions);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return (
      <ErrorState isFullPage errorType={ERROR_TYPES.API_ERROR} error={error} />
    );
  }

  if (currentStep) {
    return currentStep.component;
  }

  return <BasePage>{children}</BasePage>;
};
